import {
  Select,
  SelectProps,
  MenuItem,
  FormControl,
  InputLabel,
  FormHelperText,
} from '@mui/material';
import { useField } from 'formik';

type FormikDropDownProps = {
  name: string;
  label: string;
  options: Array<{
    value: string | number;
    label: string;
  }>;
} & Omit<SelectProps, 'name'>;

export const FormikDropDown = ({ name, label, options, ...props }: FormikDropDownProps) => {
  const [field, meta] = useField(name);

  return (
    <FormControl
      variant="filled"
      fullWidth
      error={meta.touched && Boolean(meta.error)}
      sx={{
        '& .MuiInputBase-input': { fontSize: '16px' },
        '& .MuiFormLabel-root': { fontSize: '14px' },
        ...props.sx,
      }}
    >
      <InputLabel id={`${name}-label`}>{label}</InputLabel>
      <Select labelId={`${name}-label`} label={label} {...field} value={field.value ?? ''} {...props}>
        {options.map((option) => (
          <MenuItem key={option.value} value={option.value}>
            {option.label}
          </MenuItem>
        ))}
      </Select>
      {meta.touched && meta.error && <FormHelperText>{meta.error}</FormHelperText>}
    </FormControl>
  );
};
